module.exports = __webpack_public_path__ + "img/icon-alipay.47b7745a.svg";